export default "/kiban/_next/static/images/routerCut-6396e444f6eac9c95b07bfebb3ad9339.png";